"use client";

import { Button, Skeleton } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";

export default function LoadingMobile() {
  return (
    <>
      <div className="max-w-7xl mx-auto px-4 py-4">
        <h1 className="text-2xl">My Shopping Cart</h1>
      </div>
      <div className="space-y-4">
        <div className="bg-white divide-y divide-zinc-200">
          {[1, 2].map((_, i) => (
            <div key={i} className="p-4">
              <div className="inline-flex gap-x-4 items-center">
                <Skeleton width={64} height={64} variant="rounded" />
                <div className="space-y-2">
                  <Skeleton width={180} variant="rounded" />
                  <Skeleton width={80} variant="rounded" />
                </div>
              </div>
              <div className="flex justify-between items-center gap-3">
                <Button disabled>Delete</Button>

                <div className="flex flex-nowrap">
                  <button
                    type="button"
                    className="rounded text-zinc-500 bg-zinc-100 shrink-0 size-[30px] grid place-items-center cursor-pointer"
                  >
                    <RemoveRoundedIcon fontSize="small" />
                  </button>
                  <div className="size-[30px] grid place-items-center px-1">
                    <Skeleton width={16} variant="rounded" />
                  </div>
                  <button
                    type="button"
                    className="rounded text-white shrink-0 size-[30px] grid place-items-center cursor-pointer bg-primary"
                  >
                    <AddRoundedIcon fontSize="small" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-white p-4 mb-[70px]">
          <div className="flex justify-between items-baseline gap-3 py-1">
            <div className="flex">Total</div>
            <Skeleton width={100} variant="rounded" />
          </div>
          <div className="flex justify-between items-baseline gap-3 py-1">
            <div>Shipping</div>
            <div>Calculate at Checkout</div>
          </div>
        </div>
        <div className="bg-white fixed left-0 right-0 bottom-0 p-4 border-t border-zinc-200">
          <Skeleton height={36} variant="rounded" />
        </div>
      </div>
    </>
  );
}
